import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "react-bootstrap";
import { defineMessages, injectIntl } from "react-intl";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { far } from "@fortawesome/pro-regular-svg-icons";
import useI18n from "../hooks/useI18n";
import {useLocation} from "react-router-dom";

const messages = defineMessages({
    global: {
        id: "Kansainvälinen",
        defaultMessage: "International"
    },
    fi: {
        id: "Suomi",
        defaultMessage: "Finland"
    },
    se: {
        id: "Ruotsi",
        defaultMessage: "Sweden"
    },
    no: {
        id: "Norja",
        defaultMessage: "Norway"
    }
});

const SystemCountrySelector = (props) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const { systemCountries, getCountry, getLocale, getCountryFlag } = useI18n();
    const lng = props.intl.formatMessage;
    const currentCountry = getCountry();
    const location = useLocation();
    const currentFlag = getCountryFlag(currentCountry);
    const exclude = props.exclude ?? [];

    const countryOptions = systemCountries.filter(country => !exclude.includes(country.locale));

    /**
     * Resolve link url for country dropdown item
     * @param {object} country
     * @return {string}
     */
    const resolveUrl = (country) => {
        let url = country.url;
        if (props.useCurrentPath) {
            url = `${url}${location.pathname}`;
        }
        // Add language parameter and sanitize (remove possible double slashes)
        url = `${url}?lang=${getLocale()}`.replace(/(?<!:)\/{2,}/g, '/');
        return url;
    }

    return (
        <Dropdown
            show={showDropdown}
            onToggle={(isOpen) => setShowDropdown(isOpen)}
            drop="up"
            className="system-country-selector"
        >
            <DropdownToggle
                as="button"
                className="system-country-selector-toggle"
            >
                {currentFlag
                    ? <img src={currentFlag} alt={currentCountry} aria-hidden="true" width={16} height={16} />
                    : <FontAwesomeIcon icon={far.faGlobe} aria-hidden="true" />}
                {lng(messages[currentCountry] ?? messages.global)}
            </DropdownToggle>
            <DropdownMenu className="system-country-selector-menu">
                {countryOptions.map((country) => {
                    const flag = getCountryFlag(country.locale);
                    return (
                        <DropdownItem
                            key={country.locale}
                            href={resolveUrl(country)}
                            className="system-country-selector-item"
                            active={country.locale === currentCountry}
                        >
                            {flag
                                ? <img src={flag} alt="" aria-hidden="true" width={16} height={16} />
                                : <FontAwesomeIcon icon={far.faGlobe} aria-hidden="true" />}
                            {lng(messages[country.locale])}
                        </DropdownItem>
                    );
                })}
            </DropdownMenu>
        </Dropdown>
    );
};

SystemCountrySelector.propTypes = {
    intl: PropTypes.object.isRequired,
    exclude: PropTypes.array,
    useCurrentPath: PropTypes.bool
};

export default injectIntl(SystemCountrySelector);
